import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useArray, useBoolean } from 'react-hanger';
import { PopupSelect, Img, UiToast } from 'components';

import { config, utils, hoc, request, user, globalPageConfig } from 'lib';
import { useGlobalStore } from 'stores';
import { OpenTipPopup } from './group';

// const logo = require('./images/icon-logo.png')

import Styled, { LoginArea } from './styled';
import logo from './images/icon-logo.png';

import Popup from './popup';

const defaultNavs = [
  {
    page: 'index',
    title: '首页',
    url: '/',
    sa: 'id=000b002&desc=button:首页',
  },
  {
    page: 'tag',
    title: '发现',
    url: '/tag.html',
    sa: 'id=000b003&desc=button:发现',
  },
  // {
  //   page: 'rank',
  //   title: '排行榜',
  //   url: '/rank.html',
  //   sa: 'id=000b004&desc=button:排行榜',
  // },
  {
    page: 'family',
    title: '家族',
    url: '/family',
    sa: 'id=000b005&desc=button:家族',
  },
];

const BtnStart = ({ link }) => {
  return (
    <a
      href={link}
      target={link === '#' ? '_self' : '_blank'}
      className="text-second"
      rel="noreferrer"
    >
      立即开播
    </a>
  );
};

type MenuList = {
  mm_no: number;
  theme: string;
  type: string;
};

const DownloadClient = () => {
  const handleDownload = () => {
    request.flint.get('api/v1/apps/meme/www/client_config').then((res: any) => {
      window.open(res.data.win.url);
    });
  };
  return (
    <button className="btn btn-success btn-lg" onClick={handleDownload}>
      下载直播伴侣
    </button>
  );
};

const PageHeader = observer(({ navs = defaultNavs, currentPage }) => {
  const { isLogin, userInfo } = useGlobalStore();
  const { enableWeibo } = globalPageConfig.useConfig();

  const rooms = useArray<MenuList>([]);
  const showMenu = useBoolean(false);

  useEffect(() => {
    if (isLogin) {
      request.cryolite
        .get('api/v1/stage-backend/user-as-host')
        .then((res: any) => {
          rooms.setValue(
            res.data.items.filter((item) => {
              return item.type !== 'stage' && item.type !== 'multi_pk';
            }),
          );
        })
        .catch(() => {});
    }
  }, [isLogin]);

  const onLogin = () => {
    user.popupLogin();
  };

  const onRegister = () => {
    user.popupRegister();
  };

  const { show, hide, isShow } = hoc.useShow();

  const renderStartBtn = () => {
    if (userInfo!.isAnchor) {
      if (rooms.value.length === 0) {
        return (
          <div className="start-live">
            <button onClick={redirectMyRoom} className="text-second">
              立即开播
            </button>
          </div>
        );
      }
      return (
        <div className="start-live">
          <BtnStart link="#" />
          {renderStartMenu()}
        </div>
      );
    }
    if (rooms.value.length > 1) {
      return (
        <div className="start-live">
          <BtnStart link="#" />
          {renderStartMenu()}
        </div>
      );
    }
    if (rooms.value.length === 1) {
      return (
        <div className="start-live">
          <BtnStart
            link={`${config.basePath}/${linkType[rooms.value[0].type]}/${rooms.value[0].mm_no}`}
          />
        </div>
      );
    }

    return null;
  };

  const linkType = {
    stage: 'stage',
    multi_pk: 'pk',
    funny: 'party',
  };

  const redirectMyRoom = () => {
    // return hoc.render({
    //   key: 'openGroupTip'
    // }, OpenTipPopup);
    request.cryolite
      .get('api/v1/true-love-group/my-group-info')
      .then((res: any) => {
        if (res.data.exist_love_group) {
          if (config.staging) {
            window.open(`/client/${userInfo!.mm_no}`);
          } else {
            window.open(`/${userInfo!.mm_no}`);
          }
        } else {
          hoc.render({}, OpenTipPopup);
        }
      })
      .catch(() => {
        UiToast.fail('获取真爱团信息异常');
      });
  };

  const renderStartMenu = () => {
    return (
      // @ts-ignore
      <PopupSelect
        position="bottom"
        style={{ width: '150px', right: 0, left: 'auto' }}
        className="menu fadeInUp animated speed-400"
      >
        {userInfo!.isAnchor && (
          <span className="item" onClick={redirectMyRoom}>
            我的房间
          </span>
        )}
        {rooms.value.map((item) => {
          return (
            <a
              key={item.mm_no}
              className="item text-overflow"
              target="_blank"
              href={`${config.basePath}/${linkType[item.type]}/${item.mm_no}`}
              rel="noreferrer"
            >
              {item.theme || item.mm_no}
            </a>
          );
        })}
      </PopupSelect>
    );
  };

  const onRedirectLogin = (e) => {
    const { type } = e.currentTarget.dataset;
    user.redirectThirdLogin(type);
    // return MM.user.redirectToLogin(type);
  };

  const renderLoginInfo = () => {
    if (isLogin) {
      return (
        <LoginArea>
          <i className="icon-header icon-header-coin"></i>
          <span className="user-coin text-overflow">
            {utils.formatNum(userInfo!.finance.coin_count || 0)}
          </span>
          <button onClick={user.redirectPay} className="btn btn-red">
            充值
          </button>
          <div className="avatar" onMouseEnter={show} onMouseLeave={hide}>
            <Img src={userInfo!.pic} alt={userInfo!.nick_name} />
            {isShow && <Popup close={hide}></Popup>}
          </div>

          {renderStartBtn()}
          <DownloadClient></DownloadClient>
        </LoginArea>
      );
    }
    return (
      <LoginArea>
        <a
          className="icon-login icon-header icon-header-login-wechat"
          onClick={onRedirectLogin}
          data-type="wechat"
          data-sawebclick="id=000b008&desc=button:微信登录"
        ></a>
        <a
          data-type="qq"
          className="icon-login icon-header icon-header-login-qq"
          onClick={onRedirectLogin}
          data-sawebclick="id=000b009&desc=button:QQ登录"
        ></a>
        {enableWeibo && (
          <a
            data-type="sina"
            className="icon-login icon-header icon-header-login-weibo"
            onClick={onRedirectLogin}
            data-sawebclick="id=000b010&desc=button:微博登录"
          ></a>
        )}
        <div
          className="btn btn-outline-white btn-lg"
          onClick={onLogin}
          data-sawebclick="id=000b012&desc=button:登录"
        >
          登录
        </div>
        <div
          onClick={onRegister}
          className="btn btn-outline-second btn-lg"
          data-sawebclick="id=000b013&desc=button:注册"
        >
          注册
        </div>
        <DownloadClient></DownloadClient>
      </LoginArea>
    );
  };

  return (
    <Styled id="top-header">
      <div className="container clearfix">
        <div className="header-left">
          <a href="/" className="link-home" data-log="event=click_log&desc=点击顶部logo">
            <Img src={logo} alt="么么直播" />
          </a>
          <a
            className="btn btn-round btn-red btn-mobile-download clearfix "
            href="/download.html"
            target="_blank"
            data-sawebclick="id=000b001&desc=button:下载APP"
          >
            <i className="icon-header icon-header-mobile-download"></i>
            <span>下载App</span>
            <div className="header-qrcode">
              <i className="icon-header icon-header-qrcode"></i>
              <div>扫码下载APP</div>
              <div>和孤单说拜拜</div>
            </div>
          </a>
          <div className="header-navs">
            {navs.map((item) => {
              return (
                <a
                  key={item.page}
                  href={item.url}
                  className={`nav ${currentPage === item.page ? 'active' : ''}`}
                  target="_blank"
                  data-sawebclick={item.sa}
                  rel="noreferrer"
                >
                  <span>{item.title}</span>
                  <i className="nav-bottom-line"></i>
                </a>
              );
            })}
            {currentPage === 'index' && (
              <button
                className="nav nav-search"
                data-log="event=top_search&desc=顶部搜索"
                data-sawebclick="id=000b011&desc=button:搜索"
              >
                <span>搜索</span>
                <i className="nav-bottom-line"></i>
              </button>
            )}
          </div>
        </div>
        {renderLoginInfo()}
      </div>
    </Styled>
  );
});

export default PageHeader;
